import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "./common/Button";
import { useMediaQuery } from "react-responsive";
import { getScrollRefByKey, scrollToRef } from "../backend/scrollToRef";
import { getPatronatInfoByName } from "../backend/info/patronatInfo";

const ServiceHeader = ({ onChangeMenu = (value) => {}, isMenuOpen_base = false }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(isMenuOpen_base);

  useEffect(() => {
    setIsMenuOpen(isMenuOpen_base);
  }, [isMenuOpen_base]);

  const navigate = useNavigate();

  const isFooterDouble = useMediaQuery({ query: `(max-width: 1100px)` });
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 500px)` });
  const showTwoButtons = useMediaQuery({ query: `(min-width: 1150px)` });

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  const location = useLocation();

  return (
    <>
      <header style={{ ...styles.headerContainer }}>
        <nav style={styles.navContainer}>
          {!isMobile || isMenuOpen ? (
            <div style={{ ...styles.leftSide, gap: isMobile ? "3vw" : "1rem", cursor: "pointer" }}>
              <img
                src="/assets/icons/210-logo-small.svg"
                alt="logo"
                style={{ ...styles.icon, left: 0 }}
                onClick={() => {
                  setIsMenuOpen(false);
                  onChangeMenu(false);
                  navigate("/");
                }}
              />

              <p
                style={{ ...styles.logoText, fontSize: showTwoButtons ? "1.25rem" : "1rem" }}
                onClick={() => {
                  setIsMenuOpen(false);
                  onChangeMenu(false);
                  navigate("/");
                }}
              >
                210 окремий
                <br />
                Штурмовий
                <br />
                Полк
              </p>
              {!isMenuOpen && (
                <div style={styles.leftButtonRow}>
                  <Button
                    text={"КОНТАКТИ"}
                    onClick={() => {
                      window.scrollTo({
                        top: document.documentElement.scrollHeight - (isFooterDouble ? 1700 : 1000),
                        behavior: "smooth",
                      });
                    }}
                    border="2px solid var(--white)"
                    textColor="var(--white)"
                    hoverTextColor="var(--black)"
                    hoverBackgroundColor="var(--white)"
                    fontFamily="UAFSans-Book"
                    containerProps={{ width: "min(12rem, 30vw)" }}
                    padding={isMobile ? "0.5rem 0rem" : "0.75rem 0rem"}
                    fontSize={isMobile ? "min(3.5vw, 1.25rem)" : "1.25rem"}
                  />
                  {/* {showTwoButtons && (
                    <Button
                      text={"ПІДТРИМАТИ"}
                      external_link={getPatronatInfoByName("supportLink")}
                      border="2px solid var(--white)"
                      textColor="var(--white)"
                      hoverTextColor="var(--black)"
                      hoverBackgroundColor="var(--white)"
                      fontFamily="UAFSans-Book"
                      containerProps={{ width: "min(12rem, 30vw)" }}
                      padding={isMobile ? "0.5rem 0rem" : "0.75rem 0rem"}
                      fontSize={isMobile ? "min(3.5vw, 1.25rem)" : "1.25rem"}
                    />
                  )} */}
                </div>
              )}
            </div>
          ) : (
            <div
              style={styles.menuIconContainer}
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
                onChangeMenu(!isMenuOpen);
              }}
            >
              <img src={"/assets/icons/menu.svg"} />
            </div>
          )}

          {!isMenuOpen ? (
            <div style={styles.rightSide}>
              {isMobile && !isMenuOpen && (
                <Button
                  text={"КОНТАКТИ"}
                  onClick={() => {
                    window.scrollTo({
                      top: document.documentElement.scrollHeight - (isFooterDouble ? 1700 : 1000),
                      behavior: "smooth",
                    });
                  }}
                  border="2px solid var(--white)"
                  textColor="var(--white)"
                  hoverTextColor="var(--black)"
                  hoverBackgroundColor="var(--white)"
                  fontFamily="UAFSans-Book"
                  containerProps={{ width: "min(12rem, 35vw)" }}
                  padding={isMobile ? "0.5rem 0rem" : "0.75rem 0rem"}
                  fontSize={isMobile ? "min(3.5vw, 1.25rem)" : "1.25rem"}
                />
              )}
              {/* <Button
                text={"МИ ПАМ'ЯТАЄМО"}
                internal_link={"/"}
                textColor="var(--orange)"
                hoverTextColor="var(--black)"
                border="2px solid var(--orange)"
                hoverBackgroundColor="var(--orange)"
                fontFamily="UAFSans-Book"
                containerProps={{ width: "min(12rem, 35vw)" }}
                padding={isMobile ? "0.5rem 0rem" : "0.75rem 0rem"}
                fontSize={isMobile ? "min(3.5vw, 1.25rem)" : "1.25rem"}
              /> */}
              <Button
                text={"ПІДТРИМАТИ"}
                external_link={getPatronatInfoByName("supportLink")}
                textColor="var(--orange)"
                hoverTextColor="var(--black)"
                border="2px solid var(--orange)"
                hoverBackgroundColor="var(--orange)"
                fontFamily="UAFSans-Book"
                containerProps={{ width: "min(12rem, 35vw)" }}
                padding={isMobile ? "0.5rem 0rem" : "0.75rem 0rem"}
                fontSize={isMobile ? "min(3.5vw, 1.25rem)" : "1.25rem"}
              />
            </div>
          ) : (
            <div
              style={styles.menuIconContainer}
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
                onChangeMenu(!isMenuOpen);
              }}
            >
              <img src={"/assets/icons/close.svg"} />
            </div>
          )}
        </nav>
      </header>
    </>
  );
};

const styles: Record<string, React.CSSProperties> = {
  headerContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 100,
    backgroundColor: "var(--black)",
    backdropFilter: "blur(5px)",
  },
  navContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "var(--main-container-width)",
    margin: "0 auto",
    height: "var(--header-height)",
  },
  leftSide: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  leftButtonRow: {
    display: "flex",
    flexDirection: "row",
    gap: "2rem",
    marginLeft: "2rem",
  },
  icon: {
    height: "var(--header-height)",
    position: "relative",
    left: "-46.5px", // 0.5 of its width
    cursor: "pointer",
  },
  rightSide: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  menuIconContainer: {
    width: "clamp(2rem, 7vw, 3rem)",
    height: "clamp(2rem, 7vw, 3rem)",
    cursor: "pointer",
  },
  logoText: {
    color: "var(--orange)",
    fontSize: "1.25rem",
    fontWeight: "bold",
  },
};

export default ServiceHeader;
